import React from 'react';
import {ScreenDesignerListConsumer} from "../../ContextComponents/ScreenDesignerListContext";

const ScreenDesignerListHoc = (Wrapped) => {
    return (props) => {
        return (
            <ScreenDesignerListConsumer>
                {
                    (screenProps) => {
                        return (
                            <Wrapped {...props} {...screenProps}/>
                        )
                    }
                }
            </ScreenDesignerListConsumer>
        )
    }
};
export default ScreenDesignerListHoc;